import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionUrlService {

  private secretKey = 'your-secret-key';  // Anahtar burada sabit, ama daha güvenli yöntemler kullanılabilir.

  constructor() { }

  // Şifreleme fonksiyonu
  // 🔐 Güvenli Base64 kodlama ile şifreleme
  // Şifreleme (URL-safe)
  encryptId(id: string): string {
    const encrypted = CryptoJS.AES.encrypt(id, this.secretKey).toString();
    const urlSafe = encrypted.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return urlSafe;
  }

  // Deşifreleme (URL-safe çözümleme)
  decryptId(encryptedId: string): string {
    let base64 = encryptedId.replace(/-/g, '+').replace(/_/g, '/');
    // Base64 padding düzeltmesi
    while (base64.length % 4 !== 0) {
      base64 += '=';
    }

    const bytes = CryptoJS.AES.decrypt(base64, this.secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  }

}